



































































































import { Component, Prop } from "vue-property-decorator";
import PaymentForm from "./payment-form";

@Component
class Membership extends PaymentForm {
    @Prop({type: Number}) public amount: number;
}

export default Membership;



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/scripts/components/payment-membership.vue